/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Parallax, A11y,Keyboard} from 'swiper/modules';

//Swiper.use([Navigation,Pagination,EffectFade,Parallax,A11y,Keyboard]);

(($) => {

    const swipers = document.querySelectorAll('.swiper');
    const swiperPagination = document.querySelectorAll('.swiper-pagination');

    swipers.forEach((slider, index) => {

        if( slider.classList.contains('card-swiper') ){

            const cardSwiper = new Swiper(slider, {
                modules: [Navigation,Pagination,A11y],
                slidesPerView: 1,
                spaceBetween: 15,
                speed: 1000,
                loop: false,
                a11y: {
                    enabled: true,
                    slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
                },
                pagination: {
                    el: swiperPagination[index],
                    type: "progressbar"
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    1000 : {
                        slidesPerView: 3,
                        spaceBetween: 25,
                    },
                    // when window width is >= 1200px
                    1200 : {
                        slidesPerView: 4,
                        spaceBetween: 35,
                    }
                }
            });
        }
    });

    //MAIN HERO SLIDESHOW
    const mainSwiper = new Swiper('.js-home-slideshow', {
        modules: [Navigation,Pagination,A11y,Parallax,EffectFade,Keyboard],
        effect: 'fade',
        loop: false,
        parallax: true,
        autoplay:{
            delay: 7000, //7 seconds per slide
            disableOnInteraction: false
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        a11y: {
            enabled: true,
            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            hideOnclick: false,
            clickable: true
        }
    });

})(jQuery)